var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43526 0.644986L0.838258 4.75574C0.413758 5.24099 0.758758 5.99999 1.40301 5.99999H8.59701C8.74119 6.00011 8.88236 5.95867 9.00359 5.88063C9.12483 5.80259 9.221 5.69126 9.2806 5.55997C9.34019 5.42867 9.36067 5.28299 9.3396 5.14035C9.31852 4.99772 9.25678 4.86418 9.16176 4.75574L5.56476 0.645736C5.49436 0.565179 5.40755 0.500614 5.31014 0.456377C5.21273 0.412139 5.10699 0.389252 5.00001 0.389252C4.89303 0.389252 4.78728 0.412139 4.68988 0.456377C4.59247 0.500614 4.50565 0.565179 4.43526 0.645736V0.644986Z",
    fill: "#0D6EFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUpArrow);
export default __webpack_public_path__ + "static/media/filter_up_arrow.d1c316c9887226d9668a20167b66111c.svg";
export { ForwardRef as ReactComponent };